"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MutexMap = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncMutex = require("async-mutex");
class MutexMap {
  constructor() {
    (0, _defineProperty2.default)(this, "mutexMap", {});
  }
  getMutex(key) {
    let mutex = this.mutexMap[key];
    if (!mutex) {
      mutex = new _asyncMutex.Mutex();
      this.mutexMap[key] = mutex;
    }
    return mutex;
  }
  clearMutex(key) {
    let mutex = this.mutexMap[key];
    if (mutex && !mutex.isLocked()) {
      delete this.mutexMap[key];
    }
  }
}
exports.MutexMap = MutexMap;
//# sourceMappingURL=MutexMap.js.map